import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;

  background-color: white;
  border-radius: 5px;

  max-width: 1030px;
  padding: 15px;
  margin: 0 auto;
  margin-bottom: 50px;
`;
